import * as firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/analytics';
import 'firebase/firestore';
import 'firebase/storage';
import 'firebase/functions';

import Analytics from './analytics';
const firebaseConfig = {
  apiKey: "AIzaSyAnlpinrzKgetBVZGd0rewCxV3UcdjYgzU",
  authDomain: "tournifycms.firebaseapp.com",
  databaseURL: "https://tournifycms.firebaseio.com",
  projectId: "tournifycms",
  storageBucket: "tournifycms.appspot.com",
  messagingSenderId: "586302568845",
  appId: "1:586302568845:web:8744ea1ca765a9ef7965c4",
  measurementId: "G-VG3H5D544R"
};

class Firebase {
  initialize(){
    firebase.initializeApp(firebaseConfig);
    this.firebase = firebase;
    firebase.analytics();
    const analytics = new Analytics(firebase.analytics);
    this.auth = firebase.auth;
    this.analytics = analytics;
    this.storage = firebase.storage();
    this.db = firebase.firestore();
    this.functions = firebase.functions();
  }
}

export default new Firebase();